import React from 'react';

import {PaperDarkBG, Headline, Subline, Subline2 } from "../kits/DesignKit";


function SectionA() {
  return (
   
  
    <PaperDarkBG>
      {/* Die oben definierte Section */}
      <section className=" py-20 sm:py-16 md:py-20">
        <div className="container mx-auto text-center px-10">
          <h1 className="text-sl sm:text-xl md:text-xl font-mono text-gray-50 mb-4">
            Ich entwickle <span className="text-orange-300">Lösungen</span> die wirklich <span className="text-orange-300">tragen</span>
          </h1>
          <p className="italic text-xs font-mono sm:text-xs md:text-xs text-gray-50">
            Software- & Medienlösungen mit echter Wirkung. <br />
          </p>
        </div>
      </section>
      
      {/* Weitere Sections oder Inhalte hier */}
    </PaperDarkBG>
    
  );
}

export default SectionA;